// @ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import { Text } from 'platform-components';
import { POPUP_AXIS, POPUP_DIRECTIONS } from 'platform-components/constants';
import LessonMeta from 'platform-components/src/components/lesson-meta';
import { withRouterPath } from 'platform-components/hocs';
import React from 'react';
import { connect } from 'react-redux';
import { Action, bindActionCreators, compose, Dispatch } from 'redux';

import { getShouldShowModal as getShouldShowLessonModal } from 'common.components/lesson-view.store/selectors';
import { getSubjectFromPath } from 'utils/path';

import { actions as lessonWidgetActions } from '../actions';
import { getShouldShowWidget, getShouldShowWidgetTooltip } from '../selectors';

import './lesson-editor-widget__info.scss';

interface StoreProps {
    shouldShowWidgetTooltip: boolean;
}

interface DispatchProps {
    toggleWidgetTooltip: (show: boolean) => void;
}

interface WidgetProps extends StoreProps, DispatchProps {
    isEmpty: boolean;
    numberOfCards: number;
    subject: SUBJECTS_SLUGS;
}

export class LessonEditorWidgetInfo extends React.PureComponent<WidgetProps> {
    onTooltipToggle = ({ shown }: { shown: boolean }) => {
        const { toggleWidgetTooltip } = this.props;

        if (!shown) {
            toggleWidgetTooltip(false);
        }
    };

    render() {
        const { isEmpty, numberOfCards, subject, shouldShowWidgetTooltip } = this.props;
        const lessonNameId: string = isEmpty ? 'lesson-editor-widget.name.new' : `lesson-editor-widget.name.${subject}`;

        return (
            <div className="lesson-editor-widget__info">
                <div className="lesson-editor-widget__info-header">
                    <Text id={lessonNameId} weight={Text.WEIGHT.M} />
                </div>
                <LessonMeta.CardsCount
                    cardsCount={numberOfCards}
                    mix="lesson-editor-widget__info-description"
                    shouldShowWarning={true}
                    tooltipProps={{
                        direction: POPUP_DIRECTIONS.TOP,
                        axis: POPUP_AXIS.CENTER,
                        shown: shouldShowWidgetTooltip,
                        offsetTop: -12,
                        onToggle: this.onTooltipToggle,
                    }}
                />
            </div>
        );
    }
}

const mapStateToProps = (storeState: any): StoreProps => {
    const subject = getSubjectFromPath();

    const shouldShowWidget = getShouldShowWidget(storeState, { subject });
    const shouldShowLessonModal = getShouldShowLessonModal(storeState);
    const shouldShowWidgetTooltip = getShouldShowWidgetTooltip(storeState);

    return {
        shouldShowWidgetTooltip: shouldShowWidget && !shouldShowLessonModal && shouldShowWidgetTooltip,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return bindActionCreators(
        {
            toggleWidgetTooltip: lessonWidgetActions.toggleLessonWidgetTooltip,
        },
        dispatch
    );
};

export default compose<any>(withRouterPath, connect(mapStateToProps, mapDispatchToProps))(LessonEditorWidgetInfo);
